 export default {
    state () {
        return {
            pageTypes: [],
        }
    },
    mutations: {
        setPagesType(state, payload) {
            state.pageTypes = payload;
        },
    },

    getters: {
        getPageTypes: (state) => state.pageTypes,
    }
}